module.exports = __webpack_public_path__ + "static/media/honey-chipotle-chicken-noodles.d81da551.png";